import store from 'App/globalState/store';
import axios from 'axios';
import { errorHandler } from '../errorHandling/errorHandler';

export const serverURL = process.env.REACT_APP_BACKEND_URL;
export const baseURL = serverURL + "api/";
axios.defaults.baseURL = baseURL;

const apiHash = process.env.REACT_APP_API_PASSWORD;
const splitMarks = process.env.REACT_APP_API_SPLIT_MARKS;

const XOR_HEX = (a: string, b: string): string => {
    let res = "";
	let l = Math.max(a.length, b.length);

    for (let i = 0; i < l; i += 1) {
		let charCode = a.charCodeAt(i) ^ b.charCodeAt(i);
		let splitter = splitMarks.charAt(Math.floor(Math.random() * (splitMarks.length - 1)));
        res += `${charCode}${splitter}`;
		//console.log(a.charAt(i), a.charCodeAt(i), b.charAt(i), b.charCodeAt(i), charCode);
	}

    return res.slice(0, -1);
}

axios.interceptors.request.use(
	(config) => {
		// token interceptor goes here
		const token = store.getState().global?.auth?.tokens?.accessToken;
		if (token)
			config.headers.Authorization = `Bearer ${token}`;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axios.interceptors.request.use((config) => {
	const now = new Date().toISOString().split('.')[0];
	const password = XOR_HEX(apiHash, now);
	config.headers["X-API-CODE"] = password;
	return config;
})

axios.interceptors.response.use(null, errorHandler);
axios.defaults.withCredentials = true;
